export const QUERY_KEYS = {
  dashboard: ['dashboard'] as const,
  items: ['items'] as const,
  item: (id: string) => ['items', id] as const,
  scenes: ['scenes'] as const,
  logs: ['logs'] as const,
  log: (id: string) => ['logs', id] as const,
  conversation: (logId: string) => ['logs', logId, 'conversation'] as const,
  stats: {
    overview: (days?: number) => ['stats', 'overview', days] as const,
    scenes: ['stats', 'scenes'] as const,
    retention: (days?: number) => ['stats', 'retention', days] as const,
    progress: (days?: number) => ['stats', 'progress', days] as const,
  },
  books: ['books'] as const,
  book: (id: string) => ['books', id] as const,
  chapters: (bookId: string) => ['books', bookId, 'chapters'] as const,
  settings: ['settings'] as const,
  tags: ['tags'] as const,
  keys: ['keys'] as const,
} as const;

export const STATUS_COLORS: Record<string, string> = {
  new: 'bg-blue-100 text-blue-700',
  learning: 'bg-amber-100 text-amber-700',
  recognized: 'bg-emerald-100 text-emerald-700',
  mastered: 'bg-green-100 text-green-700',
};

export const LOG_TYPE_COLORS: Record<string, string> = {
  training: 'bg-indigo-100 text-indigo-700',
  review: 'bg-pink-100 text-pink-700',
};
